import type { ToastOptions } from "@/components/ui"

export interface FlashToastState {
  flashToast?: {
    kind: "success" | "info" | "error"
    titleKey: string
    descriptionKey?: string
  }
}

export const isFlashToastState = (value: unknown): value is FlashToastState =>
  typeof value === "object" && value !== null && "flashToast" in value

export const toFlashToastOptions = (
  flashToast: NonNullable<FlashToastState["flashToast"]>,
  translate: (key: string) => string
): { kind: "success" | "info" | "error" } & ToastOptions => ({
  kind: flashToast.kind,
  title: translate(flashToast.titleKey),
  ...(flashToast.descriptionKey ? { description: translate(flashToast.descriptionKey) } : {}),
})
